import { render, staticRenderFns } from "./EditCompanySsoConfigurations.vue?vue&type=template&id=2c236af6&scoped=true"
import script from "./EditCompanySsoConfigurations.vue?vue&type=script&lang=ts"
export * from "./EditCompanySsoConfigurations.vue?vue&type=script&lang=ts"
import style0 from "./EditCompanySsoConfigurations.vue?vue&type=style&index=0&id=2c236af6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c236af6",
  null
  
)

export default component.exports